
let API_URL, BASE_URL, REACT_APP_HOMEPAGE_URL, PREFIX;

const getTenantFromURL = () => {
  const url = window.location.hostname;
  const tenantId = url.split('.')[0];
  return url;
};

const currentURL = getTenantFromURL();

// console.log(currentURL);

if (currentURL === 'localhost') 
{
  API_URL = 'https://dan.ramatechno.com/api';
  BASE_URL = 'http://localhost:3000';
  REACT_APP_HOMEPAGE_URL = 'https://localhost:3000';
  PREFIX = 'sdm';
}
if (currentURL === 'ddsnacks.co.uk') {
  API_URL = 'https://dan.ramatechno.com/api';
  BASE_URL = 'https://ddsnacks.co.uk';
  REACT_APP_HOMEPAGE_URL = 'https://ddsnacks.co.uk';
  PREFIX = 'dds';
}

if (currentURL === 'sales.ddsnacks.co.uk') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://sales.ddsnacks.co.uk';
  REACT_APP_HOMEPAGE_URL = 'https://sales.ddsnacks.co.uk';
  PREFIX = 'dds';
}


if (currentURL === 'dan.ramatechno.com') {
  API_URL = 'https://dan.ramatechno.com/api';
  BASE_URL = 'https://dan.ramatechno.com';
  REACT_APP_HOMEPAGE_URL = 'https://dan.ramatechno.com';
  PREFIX = 'dan';
}


if (currentURL === 'karoon.rameegroup.co.in') {
  API_URL = 'https://testapi.rameegroup.co.in';
  BASE_URL = 'https://karoon.rameegroup.co.in';
  REACT_APP_HOMEPAGE_URL = 'https://karoon.rameegroup.co.in';
  PREFIX = 'knm';
}

if (currentURL === 'tsdev.rameegroup.co.in') {
  API_URL = 'https://devapi.rameesystems.com';
  BASE_URL = 'https://tsdev.rameegroup.co.in';
  REACT_APP_HOMEPAGE_URL = 'https://tsdev.rameegroup.co.in';
  PREFIX = 'tsc';
}

//production

if (currentURL === 'aytac.rameesystems.com') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://aytac.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://aytac.rameesystems.com';
  PREFIX = 'ayt';
}

if (currentURL === 'sales.kmfood.co.uk') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://sales.kmfood.co.uk';
  REACT_APP_HOMEPAGE_URL = 'https://sales.kmfood.co.uk';
  PREFIX = 'knm';
}


if (currentURL === 'sales.tschilledfoods.com') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://sales.tschilledfoods.com';
  REACT_APP_HOMEPAGE_URL = 'https://sales.tschilledfoods.com';
  PREFIX = 'tsc';
}


if (currentURL === 'dds.ebusso.com') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://dds.ebusso.com';
  REACT_APP_HOMEPAGE_URL = 'https://dds.ebusso.com';
  PREFIX = 'ddd';
}

if (currentURL === 'daninternational.rameesystems.com') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://daninternational.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://daninternational.rameesystems.com';
  PREFIX = 'dan';
}
if (currentURL === 'sales.everestcashandcarryuk.com') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://sales.everestcashandcarryuk.com';
  REACT_APP_HOMEPAGE_URL = 'https://sales.everestcashandcarryuk.com';
  PREFIX = 'eve';
}
if (currentURL === 'everest.rameesystems.com') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://everest.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://everest.rameesystems.com';
  PREFIX = 'eve';
}
if (currentURL === 'demo.ebusso.com') {
  API_URL = 'https://api.rameesystems.com';
  BASE_URL = 'https://demo.ebusso.com';
  REACT_APP_HOMEPAGE_URL = 'https://demo.ebusso.com';
  PREFIX = 'ebu';
}
if (currentURL === 'aytec.ramatechno.com') 
  {
  API_URL = 'https://aytec.ramatechno.com/api';
  BASE_URL = 'https://aytec.ramatechno.com';
  REACT_APP_HOMEPAGE_URL = 'https://aytec.ramatechno.com';
  PREFIX = 'ayy';
}

if (currentURL === 'manas.rameesystems.com') 
  {
  API_URL = 'https://manas.rameesystems.com/api';
  BASE_URL = 'https://manas.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://manas.rameesystems.com';
  PREFIX = 'sdm';
}
if (currentURL === 'rhv.rameesystems.com') 
{
  API_URL = 'https://manas.rameesystems.com/api';
  BASE_URL = 'https://rhv.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://rhv.rameesystems.com';
  PREFIX = 'rhv';
}


export { API_URL, BASE_URL, REACT_APP_HOMEPAGE_URL, PREFIX };


const Config = {

  API_URL: API_URL,
  BASE_URL: BASE_URL,
  LOG_OUT: BASE_URL,
  PREFIX: PREFIX,
};


export default Config;


